import ListView from "../../../components/listView/ListView";
import Page from "../../../components/pageView/Page";
import WidgetPage from "../../../components/widgetPage/WidgetPage";
import StepView from "../../../components/stepView/StepView";

const routesSales = [
  {
    path: "/sales",
    element: WidgetPage,
    props: {
      type: "sales",
      draggable: false,
      resizable: false,
    },
  },
  {
    path: "/sales/contact",
    element: ListView,
    props: {
      type: "contactList",
      options: { viewFilters: true, fixedServerFilter: 'contactType:customer|both|undefined' },
    },
  },
  {
    path: "/sales/paymentTerm",
    element: ListView,
    props: {
      type: "paymentTermList",
    },
  },
  {
    path: "/sales/paymentTerm/:id",
    element: Page,
    props: {
      type: "paymentTermPage",
      options: {
        mode: "edit",
        load: true,
        onMount: 'expand',
      },
    },
  },
  {
    path: "/sales/paymentTerm/new",
    element: Page,
    props: {
      type: "paymentTermPage",
      options: { mode: "new", load: false },
    },
  },
  {
    path: "/sales/contact/:id",
    element: Page,
    props: {
      type: "contactMultiPage",
      options: {
        mode: "edit",
        load: true,
        onMount: 'collapse',
      },
    },
  },
  {
    path: "/sales/contact/new",
    element: Page,
    props: {
      type: "contactPage",
      options: { mode: "new", load: false, defaultValues: { contactType: 'customer' } },
    },
  },
  {
    path: "/sales/contact/:id/interaction/:id2",
    element: Page,
    props: {
      type: "interactionPage",
      options: { mode: "edit", load: true },
    },
  },
  {
    path: "/sales/contact/:id/interaction/new",
    element: Page,
    props: {
      type: "interactionPage",
      options: { mode: "new", load: false },
    },
  },
  {
    path: "/sales/contact/:id/contactPerson/:id2",
    element: Page,
    props: {
      type: "contactPersonPage",
      options: { mode: "edit", load: true },
    },
  },
  {
    path: "/sales/contact/:id/contactPerson/new",
    element: Page,
    props: {
      type: "contactPersonPage",
      options: { mode: "new", load: false },
    },
  },
  {
    path: "/sales/product",
    element: ListView,
    props: {
      type: "productList",
    },
  },
  {
    path: "/sales/product/:id",
    element: Page,
    props: {
      type: "productPage",
      options: { mode: "edit", load: true },
    },
  },
  {
    path: "/sales/product/new",
    element: Page,
    props: {
      type: "productPage",
      options: { mode: "new", load: false },
    },
  },
  {
    path: "/sales/priceList",
    element: ListView,
    props: {
      type: "priceListList",
    },
  },
  {
    path: "/sales/priceList/:id",
    element: Page,
    props: {
      type: "priceListPage",
      options: {
        mode: "edit",
        load: true,
        onMount: 'collapse',
      },
    },
  },
  {
    path: "/sales/priceList/new",
    element: Page,
    props: {
      type: "priceListPageNew",
      options: { mode: "new", load: false },
    },
  },
  {
    path: "/sales/priceList/:id/priceListItem/:id2",
    element: Page,
    props: {
      type: "priceListItemPage",
      options: { mode: "edit", load: true },
    },
  },
  {
    path: "/sales/priceList/:id/priceListItem/new",
    element: Page,
    props: {
      type: "priceListItemPage",
      options: { mode: "new", load: false },
    },
  },
  {
    path: "/sales/invoice",
    element: ListView,
    props: {
      type: "invoiceList",
    },
  },
  {
    path: "/sales/invoice/:id",
    element: Page,
    props: {
      type: "invoicePage",
      options: {
        mode: "edit",
        load: true,
        onMount: 'collapse',
        resizeable: true,
      },
    },
  },
  {
    path: "/sales/invoice/new",
    element: Page,
    props: {
      type: "invoicePage",
      options: {
        mode: "new",
        load: false,
        onMount: 'collapse',
        resizeable: true,
      },
    },
  },
  {
    path: "/sales/invoice/:id/payment",
    element: Page,
    props: {
      type: "invoicePaymentPage",
      options: {
        mode: "edit",
        load: false,
        onMount: 'collapse',
        resizeable: true,
      },
    },
  },
  {
    path: "/sales/contact/:id/invoice/new",
    element: Page,
    props: {
      type: "invoiceFromContactPage",
      options: {
        mode: "new",
        load: false,
        onMount: 'collapse',
        resizeable: true,
        createFromEntity: 'contact'
      },
    },
  },
  {
    path: "/sales/creditNote",
    element: ListView,
    props: {
      type: "creditNoteList",
    },
  },
  {
    path: "/sales/creditNote/:id",
    element: Page,
    props: {
      type: "creditNotePage",
      options: {
        mode: "edit",
        load: true,
        onMount: 'collapse',
        resizeable: true,
      },
    },
  },
  {
    path: "/sales/invoice/newFromQuote/:id",
    element: Page,
    props: {
      type: "invoiceNewFromQuotePage",
      options: {
        mode: "new",
        load: true,
        onMount: 'collapse',
        resizeable: true,
      },
    },
  },
  {
    path: "/sales/quote/newShipment/:id",
    element: Page,
    props: {
      type: "shipmentFromQuotePage",
      options: {
        mode: "new",
        load: true,
        onMount: 'collapse',
        resizeable: true,
      },
    },
  },
  {
    path: "/sales/creditNote/newFromInvoice/:id",
    element: Page,
    props: {
      type: "creditNoteNewPage",
      options: {
        mode: "new",
        load: true,
        onMount: 'collapse',
        resizeable: true,
      },
    },
  },
  {
    path: "/sales/creditNote/new",
    element: StepView,
    props: {
      type: "creditNoteWizard"
    },
  },
  {
    path: "/sales/creditNote/new/:id",
    element: StepView,
    props: {
      type: "creditNoteWizard",
      options: {
        step: 1
      },
    },
  },
  {
    path: "/sales/quote",
    element: ListView,
    props: {
      type: "quoteList",
    },
  },
  {
    path: "/sales/quote/:id",
    element: Page,
    props: {
      type: "quotePage",
      options: {
        mode: "edit",
        load: true,
        onMount: 'collapse',
        resizeable: true,
      },
    },
  },
  {
    path: "/sales/quote/new",
    element: Page,
    props: {
      type: "quotePage",
      options: {
        mode: "new",
        load: false,
        onMount: 'collapse',
        resizeable: true,
      },
    },
  },
  {
    path: "/sales/settings",
    element: Page,
    props: {
      type: "salesSettingsPage",
      options: {
        mode: "edit",
        load: true,
        onMount: 'collapse'
      },
    },
  },
];

export default routesSales;
